// Brand constants for Rent Lupi
export const BRAND_NAME = "Rent Lupi";
export const BRAND_TAGLINE_IT = "Dal 1982 · Marciana Marina · Isola d'Elba";
export const BRAND_TAGLINE_EN = "Since 1982 · Marciana Marina · Elba Island";

// Company / Tax information
export const BRAND_LEGAL_NAME = "LUPI GIORGIO";
export const BRAND_LEGAL_ADDRESS = "Località Caparutoli, 1 · Marciana Marina 57033 (LI)";
export const BRAND_FISCAL_CODE = "LPUGRG62B14E931G";
export const BRAND_VAT = "00655790491";
export const BRAND_PEC = "lupigiorgio@pec.it";
// Operational email (read by Marco). Used for general customer comms.
export const BRAND_EMAIL = "lupiservice@hotmail.it";
// Chamber of Commerce REA registration (CCIAA Livorno). Mandatory in footer
// for sole proprietorships enrolled in the business register (art. 2250 c.c.).
export const BRAND_REA = "LI-68926";
// EU Online Dispute Resolution platform — mandatory link for B2C online sellers
// (Reg. UE 524/2013, art. 14). Must be visible and clickable.
export const BRAND_ODR_URL = "https://ec.europa.eu/consumers/odr/";

// Address & contacts
export const BRAND_ADDRESS_STREET = "Località Caparutoli, 1";
export const BRAND_ADDRESS_CITY = "57033 Marciana Marina (LI)";
export const BRAND_ADDRESS = `${BRAND_ADDRESS_STREET}, ${BRAND_ADDRESS_CITY}`;
export const BRAND_PHONE = "+390565904134"; // E.164 for tel: hrefs (works for international callers)
export const BRAND_PHONE_DISPLAY = "0565 904134"; // pretty UI label
// WhatsApp business — same line as phone, single business number
export const BRAND_WHATSAPP_DISPLAY = "0565 904134";
export const BRAND_WHATSAPP = "+390565904134"; // E.164 for wa.me link

// Geo (Marciana Marina, Caparutoli). Approximate — refine later if needed.
export const BRAND_GEO_LAT = 42.8079;
export const BRAND_GEO_LNG = 10.1936;
export const BRAND_PLACE_QUERY = "Lupi Service Marciana Marina";

// Navigation deep-links
export const BRAND_MAPS_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(BRAND_PLACE_QUERY + ", " + BRAND_ADDRESS)}`;
export const BRAND_WAZE_URL = `https://waze.com/ul?ll=${BRAND_GEO_LAT}%2C${BRAND_GEO_LNG}&navigate=yes`;
export const BRAND_APPLE_MAPS_URL = `https://maps.apple.com/?daddr=${BRAND_GEO_LAT},${BRAND_GEO_LNG}&q=${encodeURIComponent(BRAND_NAME)}`;

// Embedded map (no API key needed) — uses the precise Google CID for "Lupi Service Officina e Centro Revisioni"
export const BRAND_MAP_EMBED_URL = `https://maps.google.com/maps?q=Lupi+Service+Officina+e+Centro+Revisioni+Marciana+Marina&t=&z=15&ie=UTF8&iwloc=B&output=embed`;

// Google reviews — precise CID link straight to the business page
export const BRAND_REVIEWS_URL = `https://www.google.com/maps?cid=11207785146857683819`;
export const BRAND_REVIEWS_RATING = 4.6;
export const BRAND_REVIEWS_COUNT = 162;

export const BRAND_LOGO = "https://customer-assets.emergentagent.com/job_scooter-app-2/artifacts/vc8ovvgn_FB0ED2EE-4B57-45A6-B8E4-EF94F3588925.png";
// All hero / login backgrounds are Marco's own drone shots of the Elba island
// (Marciana Marina, Capo Sant'Andrea, Cala Alberello, sunset on the harbour).
// 100% royalty-free, no third-party license risk.
export const BRAND_LOGIN_BG = "https://customer-assets.emergentagent.com/job_scooter-app-2/artifacts/5pzfny1r_IMG_0946.jpeg";
export const LOGIN_PHOTOS = [
  "https://customer-assets.emergentagent.com/job_scooter-app-2/artifacts/5pzfny1r_IMG_0946.jpeg", // Cala panoramica dall'alto
  "https://customer-assets.emergentagent.com/job_scooter-app-2/artifacts/3gf60s5v_IMG_0944.jpeg", // Cala al crepuscolo blu/arancio
  "https://customer-assets.emergentagent.com/job_scooter-app-2/artifacts/51o1phrr_IMG_0948.jpeg", // Tramonto su Marciana Marina (vista dall'alto)
  "https://customer-assets.emergentagent.com/job_scooter-app-2/artifacts/wp6y5scy_IMG_0945.jpeg", // Nuvole spettacolari sopra la costa
  "https://customer-assets.emergentagent.com/job_scooter-app-2/artifacts/27fdziw8_IMG_0949.jpeg", // Costa rocciosa vista aerea
  "https://customer-assets.emergentagent.com/job_scooter-app-2/artifacts/x9sjlk6x_IMG_0947.jpeg", // Sole arancione sul mare
  "https://customer-assets.emergentagent.com/job_scooter-app-2/artifacts/eo5uyeog_IMG_0950.jpeg", // Porto Marciana Marina notturno
  "https://customer-assets.emergentagent.com/job_scooter-app-2/artifacts/a5ig51p8_IMG_0951.jpeg", // Tramonto con cipresso (terra ferma)
];
// Primary brand colours from logo: navy + red. Cyber yellow stays as accent for CTAs.
export const BRAND_NAVY = "#0a3b8c";
export const BRAND_RED = "#c41e2a";
